import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import IndexPageSection from '../IndexPageSection';
import StepCard from '../StepCard';
import { slugify } from '../../utils';
import { HowItWorksList, HowItWorksItem } from "./styles";

const HowItWorks = ({ userCity: { market, label } }) => (
  <IndexPageSection heading={<Fragment><span>How</span> it works?</Fragment>}>
    <HowItWorksList>
      <HowItWorksItem>
        <StepCard
          number={1}
          heading="Book your ticket"
          description="Browse our list of resorts in your area. We are adding new resorts every month."
          buttonDescription={{ type: "primary", text: "Book now" }}
          linkTo={`/s/${slugify(market)}/day-pass?product=Day%20Pass&market=${label}&date=${moment().format('YYYY-MM-DD')}&guests=2&priceHi=300&priceLo=0&distanceHi=0&distanceLo=0&sortType=0&experience=Festive%2CFamily%2CTranquil`}
        />
      </HowItWorksItem>
      <HowItWorksItem>
        <StepCard
          number={2}
          heading="Check-in at hotel"
          description="Select a date and book a day pass, spa pass, or cabana."
          linkTo="https://www.blog.dayaxe.com/resorts"
          buttonDescription={{ type: "secondary", text: "Our hotels" }}
        />
      </HowItWorksItem>
      <HowItWorksItem>
        <StepCard
          number={3}
          heading="Enjoy your time"
          description="Check-in at the hotel and enjoy your daycation! Swim, relax, eat, drink, and play."
          linkTo="#ways-to-daycation"
          buttonDescription={{ type: "secondary", text: "Our Experiences" }}
        />
      </HowItWorksItem>
    </HowItWorksList>
  </IndexPageSection>
);

HowItWorks.propTypes = {
  userCity: PropTypes.instanceOf(Object),
};

const mapStateToProps = state => ({
  userCity: state.userPreferences.city
});

export default connect(mapStateToProps)(HowItWorks);
